import * as requestActionTypes from 'services/Request/actionTypes'
import getConstants from '../../constants'

import * as actionTypes from './actionTypes'

const CONSTANTS = getConstants()

export type StateType = {
  country: string
  language: string
  geoCoordinates:
    | GeoCoordinateType
    | { latitude: undefined; longitude: undefined }
  radius?: number
  limit?: number
}

const initialState = (): StateType => ({
  country: CONSTANTS.COUNTRY,
  language: CONSTANTS.LANGUAGE,
  geoCoordinates: {
    latitude: undefined,
    longitude: undefined,
  },
  radius: undefined,
  limit: CONSTANTS.RESULTS_PER_PAGE,
})

const locationReducer = (state = initialState(), action: ActionType) => {
  switch (action.type) {
    case actionTypes.COUNTRY_AND_LANGUAGE_UPDATED: {
      const { country, language } = action.payload
      return { ...state, country, language }
    }
    case actionTypes.LANGUAGE_UPDATED:
      return { ...state, language: action.payload.language }
    case actionTypes.COUNTRY_UPDATED:
      return { ...state, country: action.payload }

    case actionTypes.GEO_UPDATED:
      return {
        ...state,
        geoCoordinates: {
          latitude: action.payload.latitude,
          longitude: action.payload.longitude,
        },
        radius: action.payload.radius,
      }

    case actionTypes.GEO_CLEARED:
      return {
        ...state,
        geoCoordinates: {
          latitude: undefined,
          longitude: undefined,
        },
        radius: undefined,
      }

    case actionTypes.GEO_REQUESTED:
      return {
        ...state,
        ...(action.payload.limit ? { limit: action.payload.limit } : {}),
      }

    case requestActionTypes.SUCCEEDED:
      switch (action.meta.sourceType) {
        case actionTypes.GEO_REQUESTED:
          return {
            ...state,
            geoCoordinates: {
              latitude: action.payload.coords.latitude,
              longitude: action.payload.coords.longitude,
            },
            radius: undefined,
          }
        default:
          return state
      }

    default:
      return state
  }
}

export default locationReducer
